export default "__VITE_ASSET__B5JYEzZe__"